export const advancedSearchHelpArtical =
  'https://support.goguardian.com/s/article/How-to-use-Advanced-Search-in-Assignments'
export const advancedSearchHelpVideo =
  '//fast.wistia.net/embed/iframe/5myxzhgzbl'
